import { GetStaticPropsResult } from 'next';

import { getRutilusGraphqlClient } from '../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../src/api/graphql/queryRutilusStatic';
import { REVALIDATE } from '../../src/constants/next';
import { GetAllBrands } from '../../src/interfaces/graphql';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { getAllBrands } from '../../src/queries/rutilus/AllBrands';
import { AllBrands, IAllBrandsProps } from '../../src/views/Brands/AllBrands/AllBrands';
import { GlobalLayout } from '../../src/components/Layouts/GlobalLayout';
import { AppLogic } from '../../src/components/AppLogic/AppLogic';

export async function getStaticProps(): Promise<
  GetStaticPropsResult<IPageMetadata & IAllBrandsProps>
> {
  const client = getRutilusGraphqlClient({ serverMode: 'static' });
  const { response } = await queryRutilusStatic<GetAllBrands>(client, { query: getAllBrands });

  return {
    props: {
      _page: 'all_brands',
      _pageTitle: 'All Brands',
      brands: response?.data.entry || [],
    },
    revalidate: REVALIDATE.DAILY,
  };
}

AllBrands.getLayout = function getLayout(page: any) {
  return (
    <AppLogic pageProps={page.props}>
      <GlobalLayout hideStickyBannerGetApp>{page}</GlobalLayout>
    </AppLogic>
  );
};

export default AllBrands;
